import { gql } from '@apollo/client';
const GET_MANUFACTURER_PRODUCTION_CALENDAR_DAYS = gql `
  query GetManufacturerProductionCalendarDays(
    $manufacturerId: ID!
    $startDate: DateTime!
    $endDate: DateTime!
  ) {
    node(id: $manufacturerId) {
      ... on ManufacturerNode {
        id
        productionCalendarDays(startDate: $startDate, endDate: $endDate) {
          date
          orderIds
          orders {
            orderId
            specificationNames
          }
        }
      }
    }
  }
`;
export default GET_MANUFACTURER_PRODUCTION_CALENDAR_DAYS;
